import useSisenseAgeGroup1Dropdown from "./UseSisenseAgeGroup1Dropdown";

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import Constants from "@usas/ui-web/utils/Constants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SisenseAgeGroup1Dropdown = ({ label, name, value, error, message, onChange }) => {
  const { ageGroupOptions } = useSisenseAgeGroup1Dropdown();

  return !ageGroupOptions.options
    ? <span className={global.LoadingMsg}>{Constants.LOADING_MSG}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={ageGroupOptions.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={!ageGroupOptions.options}
      />
    );
};

export default SisenseAgeGroup1Dropdown;